import { useEffect, useState } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import st from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/common';
import { machine } from 'src/assets/images';
import { useUrlParamValue } from 'src/hooks';

const DemoDayNotFound = () => {
    const navigate = useNavigate();
    const { paramValue } = useUrlParamValue();
    const id = paramValue({ paramName: 'id' });
    const isDraft = id;
    const description = isDraft ? 'To register for Demo Day, you need to publish your venture first!.' : 'To register for Demo Day, you need to post your startup idea on Venture Verse.';

    function handleNavigate() {
        const path = id ? `/post-venture?id=${id}&type=draft` : '/venture'
        navigate(path);
    }

    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent} style={{ paddingTop: 0 }}>
                <section className={st.content}>
                    <div className={st.left}>
                        <h1 className={st.notFoundTitle}>{isDraft ? 'No Venture Published Yet!' : 'No Ventures Found'}</h1>
                        <p className={st.notFoundDescription}>
                            {description}
                        </p>
                        <div className={st.buttonGroup}>
                            <Button variant='secondary' size='small' onClick={() => navigate(-1)} style={{ width: 'auto', height: '50px', background: 'transparent' }}>Cancel</Button>
                            <Button variant='primary' size='small' onClick={handleNavigate} style={{ width: 'auto', height: '50px' }}>Go to Venture Verse</Button>
                        </div>
                    </div>
                    <div className={st.right}>
                        <img
                            src={machine}
                            alt="No Ventures Illustration"
                        />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default DemoDayNotFound;
